import http from "../utils/http-common";

const postVersion = (data: {
  service_name: string;
  version_number: string;
  release_date?: string;
  history: {
    version: string;
    releaseDate: string;
    features: string[];
}[];
  features?: string[];
}) => http.post("/version", data);

const getAllVersions = () => http.get("/version");

export default { postVersion, getAllVersions };
